module.exports = __webpack_public_path__ + "static/img/icon_login_bg.2f58789.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_login_bg.png
// module id = uyCh
// module chunks = 1